import { createSlice } from '@reduxjs/toolkit';
import { fetchCarHouseLogos, addLogoToCarHouse, removeCarHouseLogo } from '../actions/carHouseLogos-actions';

const initialState = {
  isLoading: false,
  carHouseLogos: [],
};

const carHouseLogosSlice = createSlice({
  name: 'carHouseLogos',
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchCarHouseLogos.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(fetchCarHouseLogos.fulfilled, (state, action) => {
        const carHouseLogos = action.payload;
        state.carHouseLogos = carHouseLogos;
        state.isLoading = false;
      })
      .addCase(fetchCarHouseLogos.rejected, (state, action) => {
        
      })
      .addCase(addLogoToCarHouse.fulfilled, (state, action) => {
        const newLogo = action.payload;
        state.carHouseLogos.push(newLogo);
      })
      .addCase(removeCarHouseLogo.fulfilled, (state, action) => {
        const logoId = action.payload;

        state.carHouseLogos = state.carHouseLogos.filter(
          (logo) => logo.id !== logoId
        );
      })
  },
});

export const carHouseLogosActions = carHouseLogosSlice.actions;

export default carHouseLogosSlice;
